import { CaCompositionTable } from "../dashboard/CaCompositionTable";
import { ServiceTrendSection } from "./services/components/ServiceTrendSection";
import { ServicesHighlightsGrid } from "./services/components/ServicesHighlightsGrid";
import { ServicesLoadingState } from "./services/components/ServicesLoadingState";
import { useServicesAnalytics } from "./services/hooks/useServicesAnalytics";

interface ServicesTabProps {
  from: string;
  to: string;
  basis: "accrual" | "cash";
}

export function ServicesTab({ from, to, basis }: ServicesTabProps) {
  const { composition, trend, loading, topByVolume, topByGain } = useServicesAnalytics({
    from,
    to,
    basis,
  });

  if (loading || !composition) return <ServicesLoadingState />;

  return (
    <div>
      <ServicesHighlightsGrid topByVolume={topByVolume} topByGain={topByGain} />
      <ServiceTrendSection trend={trend} />
      <CaCompositionTable composition={composition} showVolume />
    </div>
  );
}
